export default __webpack_public_path__ + "static/media/480_private01-fr-web.d548a369.png";